import React from "react";
import {GetCurrentLocale} from "./Utils";
import t,{changeLanguage} from "./I18N/TranslateHelpers";
import {useSelector} from "react-redux";
import {RootState} from "../app/RootReducer";

const HaveAnAccountBlock = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);

  return (
    !isAuthenticated ?
      <div className="row">
        <main className="col-xl-12 col-lg-12">
          <article className="card mb-4 d-flex align-items-center">
            <div className="content-body width100 row have-account">
              <div className="col-md-9">
                <h5>{t('have_account')}</h5>
                <p className="mb-0">{t('login_avantages')}</p>
              </div>
              <div className="col-md-3">
                <a href={"/" + locale + t('url_create_account')} className="btn btn-outline-primary mr-2">{t('register')}</a>
                <a href={ "/" + locale + t('url_login')} className="btn btn-primary">{ t('login')}</a>
              </div>
            </div>
          </article>
        </main>
      </div>
      :
      null
  )
}

export default HaveAnAccountBlock;


